import React, { type ReactNode } from 'react';
import clsx from 'clsx';
import { Button } from '../Button';
import { Card } from '../Card/Card';
import type { ZodObjecty } from '@repo/types/Types';
import { isZodQueryReturn, type UseZodQueryReturn } from '@repo/hooks/useZodQuery';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

export interface TableFilterProps<T extends ZodObjecty = ZodObjecty> {
  filter: UseZodQueryReturn<T>;
  children?: React.ReactNode | (() => React.ReactNode);
  className?: string;
}

export interface TableFilterButtonProps {
  className?: string;
}

export const TableFilterButtons = ({ className }: TableFilterButtonProps) => {
  const form = useZodFormContext();
  if (!form) return <></>;
  if (!isZodQueryReturn(form)) return <></>;

  return (
    <div className={clsx('flex gap-2 sm:flex-row flex-col', className)}>
      <Button size="md" type="submit" variant="primary">
        Search
      </Button>
      <Button size="md" type="button" variant="secondary" onClick={() => form.clear()}>
        Clear
      </Button>
    </div>
  );
};

export interface TableFilterSectionProps {
  className?: string;
  children?: ReactNode;
}

export const TableFilterSection = ({ children, className }: TableFilterSectionProps) => (
  <div className={clsx('flex flex-col sm:flex-row relative gap-2  ', className)}>{children}</div>
);

export const TableFilterCard = ({
  children,
  title = 'Search Parameters',
  className,
}: {
  children: ReactNode;
  title?: string;
  className?: string;
}) => (
  <Card title={title} size="sm" className={className}>
    <div className="flex flex-col gap-4">{children}</div>
  </Card>
);
